import { createContext, useContext, useState } from "react";

const translations = {
  en: {
    loading: "Loading...",
    nav_discover: "Discover", nav_dashboard: "Dashboard", nav_admin: "Admin", nav_logout: "Log out", nav_login: "Log in",
    nav_debates: "Debates",
    auth_google: "Continue with Google", auth_or: "or",
    disclaimer_text: "YouTube, Kick and the other platforms mentioned are independent companies not affiliated with StreameyeQ. Earning money through this platform is not guaranteed.",
    landing_badge: "For streamers on every major platform",
    landing_hero1: "Share the mic with your audience.",
    landing_hero2: "Get paid when you go live.",
    landing_sub: "On StreameyeQ, fans support their streamer and grab the mic — to get discovered or spark a constructive debate. Secure payments, automatic split, and escrow until the stream happens.",
    landing_cta_streamer: "I'm a streamer", landing_cta_fan: "Discover streamers",
    landing_how: "How it works",
    landing_f1t: "Automatic, editable follower verification",
    landing_f1d: "Link your YouTube or Kick channel. We verify your followers automatically, and the requirements are editable by the admin.",
    landing_f2t: "Automatic split",
    landing_f2d: "Every payment is split automatically: {s}% for the streamer, {p}% for the platform. Transparent, no surprises.",
    landing_f3t: "Escrowed payments",
    landing_f3d: "Your fans' money is held until we confirm your live stream happened. Protection for both sides.",
    landing_cta_title: "Start monetizing your community",
    landing_cta_sub: "Verify your channel in under a minute.",
    landing_cta_btn: "Create free account",
    landing_footer: "StreameyeQ · Membership for streamers",
    footer_terms: "Terms & Conditions",
    footer_privacy: "Privacy Policy",
    footer_contact: "Refunds & payments: info@streameyeq.com",
    footer_contact_link: "Contact",
    footer_madeby: "Web app created by",
    contact_title: "Contact & payment help",
    contact_subtitle: "Questions about a refund or your payments? Send us a message and our team will reply by email.",
    contact_email_label: "Support email",
    contact_email_note: "We usually reply within 1–2 business days.",
    contact_name: "Your name",
    contact_email: "Your email",
    contact_topic: "Topic",
    contact_topic_refund: "Refund",
    contact_topic_payment: "Payment / billing",
    contact_topic_general: "General question",
    contact_message: "How can we help?",
    contact_submit: "Send message",
    contact_sending: "Sending…",
    contact_ok: "Message sent — we'll get back to you by email.",
    contact_err: "Couldn't send your message. Please email us directly.",
    contact_faq_title: "Payment & refund FAQs",
    cookie_text: "We use essential cookies to keep your session active and remember your preferences. No advertising or tracking cookies.",
    cookie_accept: "Accept",
    cookie_decline: "Essential only",
    cookie_more: "Privacy Policy",
    auth_login_title: "Log in", auth_register_title: "Create your account",
    auth_login_sub: "Welcome back to your community.", auth_register_sub: "Join StreameyeQ as a streamer or a fan.",
    auth_role_streamer: "Streamer", auth_role_streamer_desc: "Get support from your fans",
    auth_role_fan: "Fan", auth_role_fan_desc: "Support your creators",
    auth_name: "Name", auth_name_ph: "Your name", auth_email: "Email", auth_password: "Password",
    auth_submit_login: "Log in", auth_submit_register: "Create account", auth_processing: "Processing...",
    auth_to_register: "Don't have an account? Sign up", auth_to_login: "Already have an account? Log in",
    auth_welcome: "Welcome, {name}!",
    link_title: "Link your channel",
    link_sub: "We fetch your public data (followers, videos and live status) to verify your channel. Requirements: {f} followers and {v} videos.",
    link_handle: "Channel username / handle",
    link_submit: "Link & verify", link_verifying: "Verifying channel...",
    link_ok: "Channel verified", link_fail: "Verification failed",
    link_ok_toast: "Channel verified successfully!",
    link_fail_toast: "Your channel doesn't meet the minimum requirements yet.",
    link_channel: "Channel:",
    link_followers_line: "Followers: {a} / {b} required",
    link_videos_line: "Videos: {a} / {b} required",
    link_mock: "Simulated data (the public API didn't respond or no API key is configured).",
    link_go_dash: "Go to my dashboard",
    dash_no_channel_title: "You haven't linked your channel yet",
    dash_no_channel_sub: "Link your YouTube or Kick channel to verify your account and start receiving support.",
    dash_link_cta: "Link channel",
    live: "Live",
    dash_verified: "Verified", dash_not_verified: "Not verified", dash_mock: "(simulated data)",
    dash_refresh: "Refresh data",
    dash_share: "Share profile",
    dash_share_copied: "Profile link copied — share it on your socials!",
    dash_share_title: "Your link to share",
    dash_share_hint: "This is the link to share with your subscribers on your social media so they can support you and take the mic on your live stream.",
    dash_share_copy: "Copy link",
    dash_verify_stream: "Verify stream & release payments", dash_verifying: "Verifying...",
    dash_verify_ok: "Stream verified! Complete each fan's mic turn to release their payment.",
    dash_verify_fail: "We couldn't detect a live stream on your channel right now.",
    dash_auto_note: "StreameyeQ also checks automatically every hour and releases payments when you're live.",
    dash_followers: "Followers", dash_videos: "Videos", dash_held: "In escrow", dash_released: "Released ({s}%)",
    dash_payments: "Payments received", dash_no_payments: "No payments yet. Share your profile with your fans.",
    dash_from: "from", dash_your_share: "your share:",
    dash_channel_updated: "Channel data refreshed",
    dash_tiers: "Support tiers", dash_tier_name: "Tier name", dash_tier_desc: "Description (optional)",
    dash_tier_price: "Price in USD", dash_create_tier: "Create tier",
    dash_tier_created: "Tier created", dash_tier_deleted: "Tier deleted",
    payouts_title: "Payouts (Stripe Connect)",
    payouts_none: "Connect your bank account to automatically receive your {s}% share when payments are released.",
    payouts_setup: "Set up payouts",
    payouts_incomplete: "Your payout setup is incomplete. Continue onboarding to activate transfers.",
    payouts_continue: "Continue setup",
    payouts_active: "Payouts active. Your share is transferred automatically when escrow is released.",
    payouts_redirecting: "Redirecting to Stripe...",
    payout_transferred: "Paid out", payout_pending: "Payout pending", payout_failed: "Payout failed",
    queue_title: "Mic queue",
    queue_sub: "Fans who paid to take the mic, sorted by tier. Add a VOD/clip link and mark done when you've given them their turn.",
    queue_empty: "No fans waiting for the mic yet.",
    queue_done: "Done",
    queue_proof_ph: "Proof link (VOD/clip URL, optional)",
    queue_strike_note: "Tip: paste a VOD/clip link showing the minute you talked to each fan. If a fan falsely claims they didn't participate, this proof lets an admin dismiss the dispute — and 3 false disputes suspend that fan's account.",
    queue_done_toast: "Turn marked done — the fan can confirm and then the payout is released",
    history_title: "Stream history",
    history_empty: "No verified streams yet.",
    history_released: "{n} payment(s) · {amt} released",
    history_verified: "stream verified · {n} in escrow",
    dash_pending_release: "In review",
    source_manual: "Manual", source_auto: "Auto",
    st_pending: "Pending", st_failed: "Failed", st_expired: "Expired",
    escrow_held: "Held", escrow_released: "Released", escrow_pending: "Pending", escrow_refunded: "Refunded",
    escrow_pending_release: "In review", escrow_disputed: "Disputed",
    discover_badge: "Verified streamers", discover_title: "Discover & support",
    discover_empty: "No verified streamers yet. Be the first!",
    discover_tiers: "{n} support tier(s) →",
    profile_not_found: "Streamer not found.",
    profile_followers: "followers", profile_videos: "videos",
    profile_protected: "Protected payment:", 
    profile_protected_desc: "your support is held in escrow until the live stream is verified. The streamer receives {s}% and StreameyeQ {p}%.",
    profile_tiers: "Support tiers", profile_no_tiers: "This streamer hasn't created support tiers yet.",
    profile_default_desc: "Support this creator directly.",
    profile_support: "Support", profile_redirecting: "Redirecting...",
    profile_login_first: "Log in to support this streamer",
    profile_msg_label: "Message for the streamer (optional)",
    profile_msg_ph: "Grab the mic: introduce yourself, propose a debate topic...",
    pq_title: "Live mic queue",
    pq_sub: "These fans already secured their turn to take the mic — support to join them!",
    fan_title: "My supports", fan_sub: "History of your contributions and their escrow status.",
    fan_empty: "You haven't supported any streamer yet.",
    fan_discover: "Discover streamers →",
    fan_held: "Held until stream is verified", fan_released: "Released to the streamer",
    fan_pending: "Payment pending", fan_refunded: "Refunded",
    fan_pending_release: "Awaiting your confirmation", fan_disputed: "In review (disputed)",
    fan_confirm_prompt: "The streamer marked your turn as done. Did you get your interaction on stream?",
    fan_confirm_btn: "Yes, I participated", fan_dispute_btn: "It didn't happen",
    fan_proof: "View proof (VOD/clip)", fan_deadline: "Auto-confirms on",
    fan_confirm_ok: "Thanks! The payment was released to the streamer.",
    fan_dispute_ok: "Reported. Our team will review it and get back to you.",
    fan_dispute_prompt: "Briefly tell us what happened (optional):",
    fan_disputed_note: "You reported this didn't happen. It's under review — the money stays protected until resolved.",
    fan_dispute_warning: "Only dispute if you truly didn't get your turn. If the streamer proves you interacted (via the VOD/clip), it counts as a strike — 3 strikes suspend your account.",
    fan_mic_pos: "Mic turn #{n}",
    fan_mic_done: "Mic turn completed",
    pay_checking: "Confirming your payment...", pay_checking_sub: "We're verifying with Stripe. This takes a few seconds.",
    pay_ok: "Payment confirmed!", pay_ok_sub: "Thank you for supporting your favorite streamer.",
    pay_escrow_note: "Your payment is held in escrow until the streamer's live stream is verified. Then the streamer's share is released.",
    pay_queue_pos: "You're #{n} in the mic queue",
    pay_view: "View my supports →",
    pay_timeout: "Payment still pending", pay_timeout_sub: "Check your dashboard later to confirm the status.",
    pay_error: "There was a problem with the payment", pay_error_sub: "We couldn't confirm the payment. Please try again.",
    pay_back: "Back to discover →",
    cancel_title: "Payment cancelled", cancel_sub: "No charge was made. You can try again anytime.",
    admin_title: "Admin panel", admin_sub: "Manage streamers, commissions and refunds.",
    admin_tab_streamers: "Streamers", admin_tab_tx: "Transactions", admin_tab_settings: "Settings",
    admin_volume: "Total volume", admin_fees: "Platform fees", admin_held: "In escrow", admin_transferred: "Transferred",
    admin_streamers: "Streamers", admin_fans: "Fans", admin_verified: "Verified channels", admin_paid: "Paid transactions",
    admin_col_channel: "Channel", admin_col_status: "Status", admin_col_total: "Total", admin_col_fees: "Fees", admin_col_actions: "Actions",
    admin_approve: "Approve", admin_revoke: "Revoke", admin_suspend: "Suspend", admin_unsuspend: "Reactivate",
    admin_suspended: "Suspended", admin_connect_yes: "Connect ✓", admin_connect_no: "No Connect",
    admin_refund: "Refund", admin_refund_ok: "Refund issued",
    admin_fee_label: "Platform fee (%)",
    admin_fee_desc: "Percentage StreameyeQ keeps from each payment. The streamer receives the rest.",
    admin_debate_split_label: "Debate pot split (%)",
    admin_debate_winner_label: "Winner (%)",
    admin_debate_loser_label: "Loser (%)",
    admin_debate_desc: "The rest of the pot goes to StreameyeQ:",
    admin_req_label: "Verification requirements",
    admin_min_followers_label: "Minimum followers",
    admin_min_videos_label: "Minimum videos",
    admin_req_desc: "Applied automatically when a streamer links or refreshes their channel.",
    admin_save: "Save", admin_saved: "Settings saved",
    admin_updated: "Updated",
    admin_empty_tx: "No transactions yet.",
    admin_tab_fans: "Refund fans",
    admin_fans_empty: "No fans have requested refunds yet.",
    admin_fans_desc: "Fans with refunds that count against them. At 3 the account is suspended automatically.",
    admin_fan_refunds: "refunds",
    admin_unban: "Unban",
    admin_unban_ok: "Fan reinstated",
    admin_refund_reason: "Refund reason",
    admin_refund_reason_not_done: "Collaboration didn't happen (counts against fan)",
    admin_refund_reason_rejected: "Streamer rejected it (doesn't count)",
    admin_tab_debates: "Debates",
    admin_tab_disputes: "Disputes",
    disp_desc: "Fans who reported an interaction didn't happen. Refund the fan or release the payment to the streamer.",
    disp_empty: "No open disputes. 🎉",
    disp_proof: "View proof (VOD/clip)",
    disp_refund: "Refund fan",
    disp_release: "Release to streamer",
    disp_released: "Payment released to the streamer",
    admin_debates_empty: "No debates with contributions yet.",
    admin_debates_desc: "Refund every contribution of an in-progress debate at once (the pot must still be in escrow).",
    admin_debate_pot: "Pot",
    admin_debate_contributors: "contributors",
    admin_refund_all: "Refund all",
    admin_refund_all_ok: "All contributions refunded",
    admin_refund_all_confirm_title: "Refund all contributions?",
    admin_refund_all_confirm_desc: "This will refund every fan who contributed to this debate. This action cannot be undone.",
    admin_cancel: "Cancel",
    admin_refund_all_confirm_btn: "Yes, refund all",
    chat_title: "StreameyeQ Assistant", chat_sub: "Ask me how StreameyeQ works",
    chat_ph: "Type your question...", chat_send: "Send",
    chat_greeting: "Hi! I'm the StreameyeQ assistant. I can explain channel verification, escrow payments, the mic queue, debates and payouts. How can I help?",
    chat_error: "The assistant is unavailable right now. Please try again.",
    chat_open: "Need help?",
    chat_fallback: "I can only answer frequently asked questions. For refund or payment details, visit our contact page. Or try one of these:",
    chat_suggest: "You can ask me:",
    refund_policy_title: "Refund policy (please read)",
    refund_policy_text: "Payments are released to the streamer one week after the turn is marked as done: if the fan does not confirm or dispute within that week, the payment is released automatically. If a refund is needed, it opens an investigation — the fan's refund is held until we investigate whether the agreed collaboration took place during the stream. Once verified, if the collaboration did not happen, it may take approximately 5 business days for the money to appear back at the financial institution the fan used to pay. We do not control that timing and do not guarantee it. Note: if a fan accumulates 3 refunds, their account may be suspended; this does not count when you (the streamer) reject the collaboration or debate.",
    refund_policy_accept: "As a streamer, I have read and accept this refund policy",
    notif_title: "Notifications", notif_empty: "No notifications yet.",
    notif_proposed: "{a} challenged you to a debate: “{t}”",
    notif_resolved: "The debate “{t}” has ended",
    notif_win: "You won! 🏆", notif_lose: "", notif_tie: "It was a tie",
    notif_refund_warning: "Heads up: you have {n} refunds. If you reach 3, your account will be suspended.",
    notif_debate_refunded: "The debate “{t}” didn't happen — contributions were refunded.",
    notif_participation_confirm: "The streamer marked your turn for “{t}” as done. Confirm you participated or dispute it within 7 days.",
    notif_dispute_rejected: "Your dispute for “{t}” was rejected (participation was proven). This counts as a strike — 3 strikes suspend your account.",
    notif_mark_read: "Mark all as read",
    upcoming_badge: "Live schedule", upcoming_title: "Upcoming debates",
    upcoming_sub: "Don't miss the scheduled live shows — mark your calendar.",
    upcoming_watch: "Watch live", upcoming_none: "",
    faq_badge: "FAQ", faq_title: "Frequently asked questions",
    faq_sub: "Everything you need to know about how StreameyeQ works.", footer_faq: "FAQ",
  },
  es: {
    loading: "Cargando...",
    nav_discover: "Descubrir", nav_dashboard: "Panel", nav_admin: "Admin", nav_logout: "Salir", nav_login: "Iniciar sesión",
    nav_debates: "Debates",
    auth_google: "Continuar con Google", auth_or: "o",
    disclaimer_text: "YouTube, Kick y las demás plataformas mencionadas son empresas independientes sin relación con StreameyeQ. Generar ingresos a través de esta plataforma no está garantizado.",
    landing_badge: "Para streamers de las principales plataformas",
    landing_hero1: "Comparte el micrófono con tu audiencia.",
    landing_hero2: "Cobra cuando sales en vivo.",
    landing_sub: "En StreameyeQ tus fans te apoyan y toman el micrófono: para darse a conocer o abrir un debate constructivo. Pagos seguros, reparto automático y custodia hasta que el stream ocurre.",
    landing_cta_streamer: "Soy streamer", landing_cta_fan: "Descubrir streamers",
    landing_how: "Cómo funciona",
    landing_f1t: "Verificación automática y editable de seguidores",
    landing_f1d: "Vincula tu canal de YouTube o Kick. Verificamos tus seguidores de forma automática y los requisitos son editables por el administrador.",
    landing_f2t: "Reparto automático",
    landing_f2d: "Cada pago se divide automáticamente: {s}% para el streamer, {p}% para la plataforma. Transparente, sin sorpresas.",
    landing_f3t: "Pagos en custodia",
    landing_f3d: "El dinero de tus fans queda retenido hasta que confirmamos que tu stream en vivo ocurrió. Protección para ambos lados.",
    landing_cta_title: "Empieza a monetizar tu comunidad",
    landing_cta_sub: "Verifica tu canal en menos de un minuto.",
    landing_cta_btn: "Crear cuenta gratis",
    landing_footer: "StreameyeQ · Mecenazgo para streamers",
    footer_terms: "Términos y condiciones",
    footer_privacy: "Política de privacidad",
    footer_contact: "Reembolsos y pagos: info@streameyeq.com",
    footer_contact_link: "Contacto",
    footer_madeby: "Web app creada por",
    contact_title: "Contacto y ayuda con pagos",
    contact_subtitle: "¿Dudas sobre un reembolso o tus pagos? Envíanos un mensaje y nuestro equipo te responderá por correo.",
    contact_email_label: "Correo de soporte",
    contact_email_note: "Solemos responder en 1–2 días hábiles.",
    contact_name: "Tu nombre",
    contact_email: "Tu correo",
    contact_topic: "Tema",
    contact_topic_refund: "Reembolso",
    contact_topic_payment: "Pago / facturación",
    contact_topic_general: "Consulta general",
    contact_message: "¿En qué podemos ayudarte?",
    contact_submit: "Enviar mensaje",
    contact_sending: "Enviando…",
    contact_ok: "Mensaje enviado — te responderemos por correo.",
    contact_err: "No se pudo enviar tu mensaje. Escríbenos directamente por correo.",
    contact_faq_title: "Preguntas frecuentes de pagos y reembolsos",
    cookie_text: "Usamos cookies esenciales para mantener tu sesión activa y recordar tus preferencias. Sin cookies de publicidad ni rastreo.",
    cookie_accept: "Aceptar",
    cookie_decline: "Solo esenciales",
    cookie_more: "Política de privacidad",
    auth_login_title: "Inicia sesión", auth_register_title: "Crea tu cuenta",
    auth_login_sub: "Vuelve a tu comunidad.", auth_register_sub: "Únete a StreameyeQ como streamer o fan.",
    auth_role_streamer: "Streamer", auth_role_streamer_desc: "Recibe apoyo de tus fans",
    auth_role_fan: "Fan", auth_role_fan_desc: "Apoya a tus creadores",
    auth_name: "Nombre", auth_name_ph: "Tu nombre", auth_email: "Correo electrónico", auth_password: "Contraseña",
    auth_submit_login: "Entrar", auth_submit_register: "Crear cuenta", auth_processing: "Procesando...",
    auth_to_register: "¿No tienes cuenta? Regístrate", auth_to_login: "¿Ya tienes cuenta? Inicia sesión",
    auth_welcome: "¡Bienvenido, {name}!",
    link_title: "Vincula tu canal",
    link_sub: "Obtenemos tus datos públicos (seguidores, videos y estado en vivo) para verificar tu canal. Requisitos: {f} seguidores y {v} videos.",
    link_handle: "Nombre de usuario / handle del canal",
    link_submit: "Vincular y verificar", link_verifying: "Verificando canal...",
    link_ok: "Canal verificado", link_fail: "Verificación fallida",
    link_ok_toast: "¡Canal verificado con éxito!",
    link_fail_toast: "Tu canal no cumple los requisitos mínimos todavía.",
    link_channel: "Canal:",
    link_followers_line: "Seguidores: {a} / {b} requeridos",
    link_videos_line: "Videos: {a} / {b} requeridos",
    link_mock: "Datos simulados (la API pública no respondió o no hay API key configurada).",
    link_go_dash: "Ir a mi panel",
    dash_no_channel_title: "Aún no has vinculado tu canal",
    dash_no_channel_sub: "Vincula tu canal de YouTube o Kick para verificar tu cuenta y empezar a recibir apoyo.",
    dash_link_cta: "Vincular canal",
    live: "En vivo",
    dash_verified: "Verificado", dash_not_verified: "No verificado", dash_mock: "(datos simulados)",
    dash_refresh: "Actualizar datos",
    dash_share: "Compartir perfil",
    dash_share_copied: "¡Enlace copiado! Compártelo en tus redes.",
    dash_share_title: "Tu enlace para compartir",
    dash_share_hint: "Este es el enlace que debes compartir con tus suscriptores en tus redes sociales para que te apoyen y tomen el micrófono en tu directo.",
    dash_share_copy: "Copiar enlace",
    dash_verify_stream: "Verificar stream y liberar pagos", dash_verifying: "Verificando...",
    dash_verify_ok: "¡Stream verificado! Completa el turno de cada fan para liberar su pago.",
    dash_verify_fail: "No detectamos una transmisión en vivo en tu canal ahora mismo.",
    dash_auto_note: "StreameyeQ también verifica automáticamente cada hora y libera los pagos cuando estás en vivo.",
    dash_followers: "Seguidores", dash_videos: "Videos", dash_held: "En custodia", dash_released: "Liberado ({s}%)",
    dash_payments: "Pagos recibidos", dash_no_payments: "Aún no has recibido pagos. Comparte tu perfil con tus fans.",
    dash_from: "de", dash_your_share: "tu parte:",
    dash_channel_updated: "Datos del canal actualizados",
    dash_tiers: "Niveles de apoyo", dash_tier_name: "Nombre del nivel", dash_tier_desc: "Descripción (opcional)",
    dash_tier_price: "Precio en USD", dash_create_tier: "Crear nivel",
    dash_tier_created: "Nivel creado", dash_tier_deleted: "Nivel eliminado",
    payouts_title: "Cobros (Stripe Connect)",
    payouts_none: "Conecta tu cuenta bancaria para recibir automáticamente tu {s}% cuando se liberen los pagos.",
    payouts_setup: "Configurar cobros",
    payouts_incomplete: "Tu configuración de cobros está incompleta. Continúa el proceso para activar las transferencias.",
    payouts_continue: "Continuar configuración",
    payouts_active: "Cobros activos. Tu parte se transfiere automáticamente al liberarse la custodia.",
    payouts_redirecting: "Redirigiendo a Stripe...",
    payout_transferred: "Transferido", payout_pending: "Transferencia pendiente", payout_failed: "Transferencia fallida",
    queue_title: "Cola de micrófono",
    queue_sub: "Fans que pagaron por tomar el micrófono, ordenados por nivel. Agrega un enlace al VOD/clip y marca como atendido cuando les des su turno.",
    queue_empty: "Aún no hay fans esperando el micrófono.",
    queue_done: "Atendido",
    queue_proof_ph: "Enlace de prueba (URL del VOD/clip, opcional)",
    queue_strike_note: "Consejo: pega un enlace al VOD/clip que muestre el minuto en que hablaste con cada fan. Si un fan miente diciendo que no participó, esta prueba permite al admin rechazar la disputa — y 3 disputas falsas suspenden la cuenta de ese fan.",
    queue_done_toast: "Turno marcado — el fan puede confirmar y luego se libera el pago",
    history_title: "Historial de streams",
    history_empty: "Aún no hay transmisiones verificadas.",
    history_released: "{n} pago(s) · {amt} liberados",
    history_verified: "stream verificado · {n} en custodia",
    dash_pending_release: "En revisión",
    source_manual: "Manual", source_auto: "Automática",
    st_pending: "Pendiente", st_failed: "Fallido", st_expired: "Expirado",
    escrow_held: "Retenido", escrow_released: "Liberado", escrow_pending: "Pendiente", escrow_refunded: "Reembolsado",
    escrow_pending_release: "En revisión", escrow_disputed: "Disputado",
    discover_badge: "Streamers verificados", discover_title: "Descubre y apoya",
    discover_empty: "Todavía no hay streamers verificados. ¡Sé el primero!",
    discover_tiers: "{n} nivel(es) de apoyo →",
    profile_not_found: "Streamer no encontrado.",
    profile_followers: "seguidores", profile_videos: "videos",
    profile_protected: "Pago protegido:",
    profile_protected_desc: "tu apoyo queda retenido en custodia hasta que se verifique la transmisión en vivo. El streamer recibe el {s}% y StreameyeQ el {p}%.",
    profile_tiers: "Niveles de apoyo", profile_no_tiers: "Este streamer aún no ha creado niveles de apoyo.",
    profile_default_desc: "Apoya directamente a este creador.",
    profile_support: "Apoyar", profile_redirecting: "Redirigiendo...",
    profile_login_first: "Inicia sesión para apoyar a este streamer",
    profile_msg_label: "Mensaje para el streamer (opcional)",
    profile_msg_ph: "Toma el micrófono: preséntate, propón un tema de debate...",
    pq_title: "Cola de micrófono en vivo",
    pq_sub: "Estos fans ya aseguraron su turno para tomar el micrófono. ¡Apoya para unirte!",
    fan_title: "Mis apoyos", fan_sub: "Historial de tus contribuciones y su estado de custodia.",
    fan_empty: "Aún no has apoyado a ningún streamer.",
    fan_discover: "Descubrir streamers →",
    fan_held: "Retenido hasta verificar stream", fan_released: "Liberado al streamer",
    fan_pending: "Pago pendiente", fan_refunded: "Reembolsado",
    fan_pending_release: "Esperando tu confirmación", fan_disputed: "En revisión (disputado)",
    fan_confirm_prompt: "El streamer marcó tu turno como realizado. ¿Tuviste tu interacción en el directo?",
    fan_confirm_btn: "Sí, participé", fan_dispute_btn: "No ocurrió",
    fan_proof: "Ver prueba (VOD/clip)", fan_deadline: "Se autoconfirma el",
    fan_confirm_ok: "¡Gracias! El pago se liberó al streamer.",
    fan_dispute_ok: "Reportado. Nuestro equipo lo revisará y te contactará.",
    fan_dispute_prompt: "Cuéntanos brevemente qué pasó (opcional):",
    fan_disputed_note: "Reportaste que no ocurrió. Está en revisión — el dinero sigue protegido hasta resolverse.",
    fan_dispute_warning: "Disputa solo si de verdad no tuviste tu turno. Si el streamer prueba que interactuaste (con el VOD/clip), cuenta como una falta — 3 faltas suspenden tu cuenta.",
    fan_mic_pos: "Turno de mic #{n}",
    fan_mic_done: "Turno de mic completado",
    pay_checking: "Confirmando tu pago...", pay_checking_sub: "Estamos verificando con Stripe. Esto toma unos segundos.",
    pay_ok: "¡Pago confirmado!", pay_ok_sub: "Gracias por apoyar a tu streamer favorito.",
    pay_escrow_note: "Tu pago queda retenido en custodia hasta que se verifique la transmisión en vivo del streamer. Después se libera su parte.",
    pay_queue_pos: "Eres el #{n} en la cola de micrófono",
    pay_view: "Ver mis apoyos →",
    pay_timeout: "El pago sigue pendiente", pay_timeout_sub: "Revisa tu panel más tarde para confirmar el estado.",
    pay_error: "Hubo un problema con el pago", pay_error_sub: "No pudimos confirmar el pago. Inténtalo de nuevo.",
    pay_back: "Volver a descubrir →",
    cancel_title: "Pago cancelado", cancel_sub: "No se realizó ningún cargo. Puedes intentarlo cuando quieras.",
    admin_title: "Panel de administración", admin_sub: "Gestiona streamers, comisiones y reembolsos.",
    admin_tab_streamers: "Streamers", admin_tab_tx: "Transacciones", admin_tab_settings: "Ajustes",
    admin_volume: "Volumen total", admin_fees: "Comisiones", admin_held: "En custodia", admin_transferred: "Transferido",
    admin_streamers: "Streamers", admin_fans: "Fans", admin_verified: "Canales verificados", admin_paid: "Transacciones pagadas",
    admin_col_channel: "Canal", admin_col_status: "Estado", admin_col_total: "Total", admin_col_fees: "Comisión", admin_col_actions: "Acciones",
    admin_approve: "Aprobar", admin_revoke: "Revocar", admin_suspend: "Suspender", admin_unsuspend: "Reactivar",
    admin_suspended: "Suspendido", admin_connect_yes: "Connect ✓", admin_connect_no: "Sin Connect",
    admin_refund: "Reembolsar", admin_refund_ok: "Reembolso emitido",
    admin_fee_label: "Comisión de plataforma (%)",
    admin_fee_desc: "Porcentaje que StreameyeQ retiene de cada pago. El streamer recibe el resto.",
    admin_debate_split_label: "Reparto del bote de debates (%)",
    admin_debate_winner_label: "Ganador (%)",
    admin_debate_loser_label: "Perdedor (%)",
    admin_debate_desc: "El resto del bote va para StreameyeQ:",
    admin_req_label: "Requisitos de verificación",
    admin_min_followers_label: "Seguidores mínimos",
    admin_min_videos_label: "Videos mínimos",
    admin_req_desc: "Se aplica automáticamente cuando un streamer vincula o refresca su canal.",
    admin_save: "Guardar", admin_saved: "Ajustes guardados",
    admin_updated: "Actualizado",
    admin_empty_tx: "Aún no hay transacciones.",
    admin_tab_fans: "Fans con reembolsos",
    admin_fans_empty: "Ningún fan ha solicitado reembolsos todavía.",
    admin_fans_desc: "Fans con reembolsos que cuentan en su contra. A los 3, la cuenta se suspende automáticamente.",
    admin_fan_refunds: "reembolsos",
    admin_unban: "Desbanear",
    admin_unban_ok: "Fan reactivado",
    admin_refund_reason: "Motivo del reembolso",
    admin_refund_reason_not_done: "La colaboración no se realizó (cuenta contra el fan)",
    admin_refund_reason_rejected: "El streamer la rechazó (no cuenta)",
    admin_tab_debates: "Debates",
    admin_tab_disputes: "Disputas",
    disp_desc: "Fans que reportaron que la interacción no ocurrió. Reembolsa al fan o libera el pago al streamer.",
    disp_empty: "No hay disputas abiertas. 🎉",
    disp_proof: "Ver prueba (VOD/clip)",
    disp_refund: "Reembolsar al fan",
    disp_release: "Liberar al streamer",
    disp_released: "Pago liberado al streamer",
    admin_debates_empty: "Aún no hay debates con aportes.",
    admin_debates_desc: "Reembolsa de golpe todos los aportes de un debate en curso (el bote debe seguir en custodia).",
    admin_debate_pot: "Bote",
    admin_debate_contributors: "aportantes",
    admin_refund_all: "Reembolsar todo",
    admin_refund_all_ok: "Todos los aportes reembolsados",
    admin_refund_all_confirm_title: "¿Reembolsar todos los aportes?",
    admin_refund_all_confirm_desc: "Se reembolsará a todos los fans que aportaron a este debate. Esta acción no se puede deshacer.",
    admin_cancel: "Cancelar",
    admin_refund_all_confirm_btn: "Sí, reembolsar todo",
    chat_title: "Asistente StreameyeQ", chat_sub: "Pregúntame cómo funciona StreameyeQ",
    chat_ph: "Escribe tu pregunta...", chat_send: "Enviar",
    chat_greeting: "¡Hola! Soy el asistente de StreameyeQ. Puedo explicarte la verificación de canal, los pagos en custodia, la cola de micrófono, los debates y los cobros. ¿En qué te ayudo?",
    chat_error: "El asistente no está disponible ahora mismo. Inténtalo de nuevo.",
    chat_open: "¿Necesitas ayuda?",
    chat_fallback: "Solo puedo responder preguntas frecuentes. Para detalles de reembolsos o pagos, visita nuestra página de contacto. O prueba una de estas:",
    chat_suggest: "Puedes preguntarme:",
    refund_policy_title: "Política de reembolsos (por favor, léela)",
    refund_policy_text: "Los pagos se liberan al streamer una semana después de marcar el turno como realizado: si el fan no confirma ni disputa dentro de esa semana, el pago se libera automáticamente. Si se necesita un reembolso, se abre una investigación — el reembolso al fan se retiene hasta que se investigue si la colaboración pactada ocurrió durante la transmisión. Una vez verificado, si la colaboración no ocurrió, puede tardar aproximadamente 5 días hábiles en que el dinero vuelva a la institución financiera que el fan usó para pagar. Ese tiempo no lo controlamos ni lo garantizamos. Nota: si un fan acumula 3 reembolsos, su cuenta podría ser dada de baja; esto no se cuenta cuando tú (el streamer) rechazas la colaboración o el debate.",
    refund_policy_accept: "Como streamer, he leído y acepto esta política de reembolsos",
    notif_title: "Notificaciones", notif_empty: "Aún no tienes notificaciones.",
    notif_proposed: "{a} te ha retado a un debate: “{t}”",
    notif_resolved: "El debate “{t}” ha finalizado",
    notif_win: "¡Ganaste! 🏆", notif_lose: "", notif_tie: "Fue un empate",
    notif_refund_warning: "Atención: tienes {n} reembolsos. Si llegas a 3, tu cuenta será suspendida.",
    notif_debate_refunded: "El debate “{t}” no ocurrió — se reembolsaron las aportaciones.",
    notif_participation_confirm: "El streamer marcó tu turno de “{t}” como realizado. Confirma que participaste o dispútalo en 7 días.",
    notif_dispute_rejected: "Tu disputa de “{t}” fue rechazada (se probó tu participación). Esto cuenta como una falta — 3 faltas suspenden tu cuenta.",
    notif_mark_read: "Marcar todo como leído",
    upcoming_badge: "Agenda en directo", upcoming_title: "Próximos debates",
    upcoming_sub: "No te pierdas los directos programados — apúntalos en tu calendario.",
    upcoming_watch: "Ver el directo", upcoming_none: "",
    faq_badge: "Preguntas frecuentes", faq_title: "Preguntas frecuentes",
    faq_sub: "Todo lo que necesitas saber sobre cómo funciona StreameyeQ.", footer_faq: "FAQ",
  },
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem("liveq_lang") || "en");
  const t = (key, vars) => {
    let s = translations[lang]?.[key] ?? translations.en[key] ?? key;
    if (vars) Object.entries(vars).forEach(([k, v]) => { s = s.replace(`{${k}}`, v); });
    return s;
  };
  const toggle = () => {
    const next = lang === "en" ? "es" : "en";
    setLang(next);
    localStorage.setItem("liveq_lang", next);
  };
  return <LangContext.Provider value={{ lang, t, toggle }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
